import { render, staticRenderFns } from "./pressure-alarm-set.vue?vue&type=template&id=0ef89b08&scoped=true"
import script from "./pressure-alarm-set.vue?vue&type=script&lang=js"
export * from "./pressure-alarm-set.vue?vue&type=script&lang=js"
import style0 from "./pressure-alarm-set.vue?vue&type=style&index=0&id=0ef89b08&prod&lang=less&scoped=true"
import style1 from "./pressure-alarm-set.vue?vue&type=style&index=1&id=0ef89b08&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef89b08",
  null
  
)

export default component.exports